// Sync the browser/PWA chrome color (<meta name="theme-color">) with the app
// theme, so the Android status bar fuses with the topbar surface instead of
// rendering a stock white strip over the cool paper. The live tokens.css
// --surface value is the source of truth (read AFTER data-theme flips, so the
// right theme block applies); the constants below are only the fallback for
// environments where the stylesheet is not loaded (jsdom tests).

export const THEME_SURFACE = { light: "#f7f9fc", dark: "#151a21" } as const;

export type ThemeName = keyof typeof THEME_SURFACE;

export function syncThemeColor(theme: ThemeName): void {
  const live = getComputedStyle(document.documentElement).getPropertyValue("--surface").trim();
  let meta = document.head.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.name = "theme-color";
    document.head.append(meta);
  }
  meta.content = live || THEME_SURFACE[theme];
}
